import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import FilterListIcon from '@material-ui/icons/FilterList';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import TableComponent from 'components/common/TableComponent/index';
import {getCollectionCaseCreditPage} from 'api/debtCollectionMonitor';
import styles from './styles.module.sass';
import cx from 'classnames';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Expansion from '../../../common/Expansion/index';
import debounce from 'lodash.debounce';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import isObject from 'lodash.isobject';

const mapStateToProps = (state) => ({
  dict: state.dictionary
});

@connect(mapStateToProps)
class ExpansionPanelCredit extends PureComponent {
  state = {
    showFilter: false,
    page: 1,
    total: -1,
    count: 10,
    sort: {},
    filter: {},
    items: [],
    itemsChange: {},
    itemsChangeAll: undefined
  };

  componentDidMount() {
    this.loadPage();
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const getPageProps = (p = {}) => {
      const {sort, filter} = p;
      return {sort, filter};
    };

    this.checkPage(getPageProps(nextState), getPageProps(this.state));

    //TODO: заглушка
    return true;
  }

  checkPage = (newState, oldState = {}) => {
    if (JSON.stringify(newState) !== JSON.stringify(oldState)) {
      this.loadPageDebounce(newState);
      return true;
    }

    return false;
  };

  loadPageDebounce = debounce((args) => this.loadPage(args), 500);

  loadPage = (params) => {
    const {collectionCaseId} = this.props;
    getCollectionCaseCreditPage(collectionCaseId, params)
      .then((data) => {
        this.setState({items: data.items, total: data.total})
      });
  };

  handlerIsInvestorAgreedOnCessionOnChange = (e, item, items) => {
    const {itemsChange} = this.state;

    const value = e.target.checked;

    const nextItem = {id: item.id, isInvestorAgreedOnCession: value};
    const nextItemsChange = {...itemsChange, [nextItem.id]: nextItem};

    this.itemsChange(nextItemsChange);
  };

  handlerAllIsInvestorAgreedOnCessionOnChange = (e, currentValue) => {
    e.stopPropagation();

    const {items} = this.state;

    let value = currentValue === null ? true : currentValue === true ? false : currentValue === false ? null : null;
    if (value === null) {
      let allFalse = true;
      items.forEach(a => {if (a.isInvestorAgreedOnCession !== false) allFalse = false;});
      if (allFalse) value = true;
    }

    const nextItemsChange = {};
    if (value != null) items.forEach(item => nextItemsChange[item.id] = {id: item.id, isInvestorAgreedOnCession: value});

    this.setState({itemsChangeAll: value});

    this.itemsChange(nextItemsChange);
  };

  itemsChange = (nextItemsChange) => {
    const {onChange, onInvestorPhysicalPersonCessionSum} = this.props;

    this.setState({itemsChange: nextItemsChange});
    if (onChange) onChange(Object.values(nextItemsChange));

    if (onInvestorPhysicalPersonCessionSum) {
      const {items} = this.state;
      const itemsChange = nextItemsChange;

      const elements = items.map(item => (Object.assign({...item}, itemsChange[item.id])));

      const investorPhysicalPersonCession = elements.filter(a => a.isInvestorAgreedOnCession === true);
      let sum = 0;
      investorPhysicalPersonCession.forEach(a => {
        const creditSum = a.creditSum || 0;
        sum = sum + creditSum;
      });

      onInvestorPhysicalPersonCessionSum(sum);
    }
  };

  getMemoryPage = (items, page, count, filter) => {
    const startPage = page * count;
    const endPage = startPage + count;

    let pageItems = items;

    if (filter) {
      const filterKeys = Object.keys(filter);

      pageItems = pageItems.filter(item => {
        for (let i = 0; i < filterKeys.length; i++) {
          let filterKey = filterKeys[i];
          let filterValue = filter[filterKey];
          let itemValue = item[filterKey];

          if (filterValue === null || filterValue === undefined || filterValue === '')
            continue;

          if (isObject(filterValue)) {
            let filterValueEq = filterValue.eq;
            let filterValueLike = filterValue.like;

            if (filterValueLike) {
              if (!itemValue)
                return false;

              if (itemValue.indexOf(filterValueLike) < 0)
                return false;
            }
            if (filterValueEq) {
              if (filterValueEq !== itemValue)
                return false;
            }

          } else {
            if (filterValue != itemValue)//использовать автоматическое приведение типов при сравнении
              return false;
          }
        }

        return true;
      });
    }

    pageItems = pageItems.filter((a, i) => i >= startPage && i < endPage);

    return pageItems;
  };

  getAllIsInvestorAgreedOnCessionState = () => {
    const {items = [], itemsChange} = this.state;

    let allTrue = true;
    let allFalse = true;
    for (let i = items.length - 1; i >= 0; i--) {
      let item = items[i];
      item = {...item, ...itemsChange[item.id]};

      if (allTrue) {
        if (item.isInvestorAgreedOnCession === false) {
          allTrue = false;
        }
      }

      if (allFalse) {
        if (item.isInvestorAgreedOnCession === true) {
          allFalse = false;
        }
      }

      if (allTrue || allFalse) {
        if (item.isInvestorAgreedOnCession !== true && item.isInvestorAgreedOnCession !== false) {
          allFalse = false;
          allTrue = false;
        }
      }

      if (allTrue === false && allFalse === false) {
        break;
      }
    }

    if (allTrue) return true;
    if (allFalse) return false;

    return null;
  };

  render() {
    const {itemsChange, filter, sort, page, total, count, showFilter} = this.state;
    const {dict, defaultExpanded} = this.props;

    if (!filter && (!items || items.length <= 0)) return null;

    let {items: allItems} = this.state;
    let items = this.getMemoryPage(allItems, page - 1, count, filter);
    items = items.map(item => (Object.assign({...item}, itemsChange[item.id])));

    const allIsInvestorAgreedOnCessionState = this.getAllIsInvestorAgreedOnCessionState();

    return (
      <Expansion
        label={'Инвесторы'}
        defaultExpanded={defaultExpanded}
      >
        <Paper className={styles.credit}>
          <div className={styles.header}>
            <Button variant="outlined" onClick={(e) => this.handlerAllIsInvestorAgreedOnCessionOnChange(e, allIsInvestorAgreedOnCessionState)}>
              <div className={styles.investorAgreedOnCessionChangeButtonContent}>
                <div>Добавить/снять отметку автоуступки</div>
                <div>
                  <Checkbox
                    style={{width: '20px', height: '20px', position: 'relative', bottom: '1px'}}
                    indeterminate={allIsInvestorAgreedOnCessionState !== true && allIsInvestorAgreedOnCessionState !== false}
                    checked={allIsInvestorAgreedOnCessionState}
                    defaultChecked
                    color="default"
                  />
                </div>
              </div>
            </Button>

            <Tooltip title={showFilter ? 'Удалить фильтр' : 'Фильтр'}>
              <IconButton className={styles.filterButton} onClick={() => this.setState({showFilter: !showFilter})}>
                {!showFilter ? <FilterListIcon className={styles.filterIcon}/> : <DeleteSweepIcon className={styles.filterIcon}/> }
              </IconButton>
            </Tooltip>
          </div>
          <div className={cx(styles.bodyBox, 'otc-date-close-if-scroll-this')}>
            <TableComponent
              onChangeFilter={(flt) => this.setState({filter: flt})}
              onChangeSort={(srt) => this.setState({sort: srt})}

              items={items}
              showFilter={showFilter}
              filter={filter}
              sort={sort}
              columns={[
                {
                  field: 'isInvestorAgreedOnCession',
                  name: 'Согласен на автоуступку',
                  width: '50px',
                  widthIfShowFilter: '50px',
                  type: 'bool',
                  format: (v, r, rs) =>
                    <Checkbox
                      indeterminate={v !== true && v !== false}
                      checked={v === true}
                      onChange={(e) => this.handlerIsInvestorAgreedOnCessionOnChange(e, r, rs)}
                      defaultChecked
                      color="default"
                    />
                },
                {field: 'name', name: 'Инвестор', width: '140px', widthIfShowFilter: '140px'},
                {field: 'creditSum', name: 'Сумма Кредита', type: 'money', width: '100px', widthIfShowFilter: '100px'},
                {field: 'contract', name: 'Договор', width: '140px', widthIfShowFilter: '140px'},
                {field: 'moneyReturned', name: 'Возврат средств', type: 'bool', format: (v) => v ? 'Да' : 'Нет', width: '45px', widthIfShowFilter: '60px'},
                {field: 'creditSumReturned', name: 'Возвращено тела кредита', type: 'money', width: '100px', widthIfShowFilter: '100px'},
                {field: 'additionalPercentSum', name: 'Начислено %', type: 'money', width: '100px', widthIfShowFilter: '100px'},
                {field: 'additionalPercentSumReturned', name: 'Возвращено %', type: 'money', width: '100px', widthIfShowFilter: '100px'},
                {field: 'penaltySum', name: 'Штрафы и неустойки', type: 'money', width: '100px', widthIfShowFilter: '100px'},
                {field: 'sendDate', name: 'Дата отправки денег', type: 'date', width: '140px', widthIfShowFilter: '140px'},
                {field: 'returnDate', name: 'Дата возврата', type: 'date', width: '140px', widthIfShowFilter: '140px'},
                {field: 'orgTypeId', name: 'Тип Инвестора', dict: dict['orgType'], width: '150px', widthIfShowFilter: '150px'},
                {field: 'phone', name: 'Основной телефон инвестора', width: '150px', widthIfShowFilter: '150px'},
                {field: 'email', name: 'Основной E-mail инвестора', width: '150px', widthIfShowFilter: '150px'}
              ]}
            />
          </div>
          <TablePagination
            component='div'
            count={total}
            rowsPerPage={count}
            page={page - 1}
            onChangePage={(e, page) => total !== -1 && this.setState({page: page + 1})}
            onChangeRowsPerPage={(e) => this.setState({count: e.target.value})}
            labelRowsPerPage='На странице'
            backIconButtonProps={{'aria-label': 'Назад'}}
            nextIconButtonProps={{'aria-label': 'Вперед'}}
            labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
            rowsPerPageOptions={[10, 15, 50, 100, 500]}
          />
        </Paper>
      </Expansion>
    );
  }
}

ExpansionPanelCredit.defaultProps = {};

ExpansionPanelCredit.propTypes = {
  collectionCaseId: PropTypes.string.isRequired,
  defaultExpanded: PropTypes.bool,
  showFilter: false,

  className: PropTypes.string,
  dict: PropTypes.object,
  onChange: PropTypes.func,
  onInvestorPhysicalPersonCessionSum: PropTypes.func
};

export default ExpansionPanelCredit;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCaseEditor/ExpansionPanelCredit/ExpansionPanelCredit.jsx